<template lang="pug">
  .analytic.report-download.report-card(:class="currentConfig.cardClass" )
    component(
      :is="modalWindowComponent"
      ref="modalForm"
      @submitModalForm="submitModal()"
      @closeModal="closeModal()"
      :hideDeleteButton="false"
      saveBtnLabel="Скачать"
      savingBtnLabel="Скачивание"
      :autoRoute="false"
      :autoHeight="true"
    )
      div(slot="header")
        template(
          v-if="currentConfig.windowType === SMALL_MODAL"
        )
          h1.modal__title Скачивание отчета
          div {{currentConfig.title}}
        template(v-else)
          e-breadcrumbs
          h1.modal__title {{currentConfig.title}}
      slot
        e-form(:formValidator="formValidator"  formClass="modal__body")
          .toolbar.toolbar--modal.toolbar--extended.toolbar_no-padding
            .toolbar__line.toolbar__line_start
              template(v-if="reportId === REPORT_NAME.MMCO")
                Year(
                  :fields="fields"
                  name="yearin"
                )
              template(v-else-if="reportId === REPORT_NAME.OBJECTS_PROCESSING")
                ActionsProcessing(
                  :fields="fields"
                )
                Group(:fields="fields")
                Lifetime(
                  :fields="fields"
                  :options="lifeTimeWithAll"
                )
                Status(
                  :fields="fields"
                  name="status_code"
                  :options="objectStatuses"
                )
              template(v-else-if="reportId === REPORT_NAME.OBJECTS_PLACING")
                ActionsStorage(:fields="fields")
                Group(:fields="fields")
                Lifetime(
                  :fields="fields"
                  :options="lifeTimeWithAll"
                )
                Status(
                  :fields="fields"
                  name="status_code"
                  :options="objectStatuses"
                )
              template(v-else-if="reportId === REPORT_NAME.TECH")
                ActionsProcessing(:fields="fields")
              template(v-else-if="reportId === REPORT_NAME.TP2")
                Group(:fields="fields")
                Detalization(:fields="fields")
                Unit(:fields="fields")
                Year(:fields="fields" name="yearin")
              template(v-else-if="reportId === REPORT_NAME.UNAUTH")
                HeapType(
                  :fields="fields"
                  :required="true"
                )
                Lifetime(
                  :fields="fields"
                  v-if="fields.heapType === GARBAGE_ORO"
                )
                Status(
                  v-if="fields.heapType === GARBAGE_ORO"
                  name="status_code"
                  :fields="fields"
                  :options="heapStatuses"
                )
                Status(
                  v-else
                  name="status"
                  :fields="fields"
                  :options="heapStatuses"
                )
              template(v-else-if="reportId === REPORT_NAME.GARBAGE_BANK")
                Group(:fields="fields" name="type")
                Detalization(:fields="fields" name="is_detail")
                Unit(:fields="fields")
                Year(:fields="fields")
                div.filter-block
              template(v-else-if="reportId === REPORT_NAME.MSN")
                MsnType(:fields="fields" :required="true")
                Status(:fields="fields")

          r-analytic-report-apo-selector(
            v-if="showApo === true"
            :fields.sync="fields"
          )
      div(slot="footer")
        .actions-filter-panel.modal__buttons.modal__buttons_space.actions-filter-panel--right
          .modal__buttons
            button(
              type="button"
              :disabled="freezeAllEvents"
              @click="closeModal()"
            ).reset-btn.button.button_no-border.button_color.modal__button Отмена
            button(
              type="button"
              :disabled="freezeAllEvents"
              @click="submitModal()"
              v-if="userCanCreate"
            ).button.reset-btn.button_usual.modal__button  Скачать
</template>

<script>
import reportDownloadMixin from './mixins/report-download-mixin'
import Year from './components/report-field/year'
import ActionsProcessing from './components/report-field/actions-processing'
import Lifetime from './components/report-field/lifetime'
import Status from './components/report-field/status'
import Group from './components/report-field/group'
import Detalization from './components/report-field/detalization'
import Unit from './components/report-field/unit'
import HeapType from './components/report-field/heap-type'
import MsnType from './components/report-field/msn-type'
import { GARBAGE_ORO } from '@/config/regions/parts/report-types'
import ActionsStorage from './components/report-field/actions-storage'

export default {
  name: 'report-download',
  components: {
    MsnType,
    HeapType,
    Unit,
    Detalization,
    Group,
    Status,
    Lifetime,
    ActionsProcessing,
    Year,
    ActionsStorage,
  },
  mixins: [reportDownloadMixin],
  computed: {
    lifeTimeWithAll() {
      return [
        { id: '0', name: 'все' },
        { id: '1', name: 'меньше 3 лет' },
        { id: '2', name: '2-3 года' },
        { id: '3', name: 'больше 3 лет' },
      ]
    },
    objectStatuses() {
      return [
        { id: 'all', name: 'Все' },
        { id: 'active', name: 'Действующий' },
        { id: 'disabled', name: 'Не действующий' },
      ]
    },
    heapStatuses() {
      return [
        { id: 'active', name: 'Действующий' },
        { id: 'disabled', name: 'Не действующий' },
      ]
    },
    GARBAGE_ORO() {
      return GARBAGE_ORO
    },
  },
}
</script>
